import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, Flame, Droplets, Battery } from 'lucide-react';
export function PainSection() {
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-151">
      <div className="max-w-4xl mx-auto" data-id="element-152">
        <div className="text-center mb-16" data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-154">
            El Ciclo de la Frustración
          </h2>
          <p className="text-xl text-brand-gray/80 max-w-2xl mx-auto" data-id="element-155">
            Has intentado la dieta Keto. Has intentado el ayuno intermitente.
            Has intentado eliminar los carbohidratos por completo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-156">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-brand-gold/10" data-id="element-157">
            <div className="flex items-center gap-4 mb-6" data-id="element-158">
              <XCircle className="w-8 h-8 text-brand-red" data-id="element-159" />
              <h3 className="text-xl font-bold text-brand-gray" data-id="element-160">
                El Resultado de Siempre
              </h3>
            </div>
            <p className="text-brand-gray/80 leading-relaxed" data-id="element-161">
              Y cada vez, el resultado es el mismo: pierdes 2 kilos, te sientes
              miserable, y recuperas 3 en cuanto vuelves a comer "normal".
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-brand-gold/10" data-id="element-162">
            <div className="flex items-center gap-4 mb-6" data-id="element-163">
              <Flame className="w-8 h-8 text-brand-gold" data-id="element-164" />
              <h3 className="text-xl font-bold text-brand-gray" data-id="element-165">
                La Verdad Biológica
              </h3>
            </div>
            <p className="text-brand-gray/80 leading-relaxed" data-id="element-166">
              A partir de los 40, tu cuerpo ha cambiado las reglas del juego. Tu
              estrógeno está cayendo, tu cortisol está por las nubes y tus
              células se han vuelto "sordas" a la insulina.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-green text-white p-8 md:p-12 rounded-3xl text-center relative overflow-hidden" data-id="element-167">
          {/* Decorative elements */}
          <Droplets className="absolute top-4 left-4 w-24 h-24 text-white/5 -rotate-12" data-id="element-168" />
          <Battery className="absolute bottom-4 right-4 w-24 h-24 text-white/5 rotate-12" data-id="element-169" />

          <h3 className="text-2xl md:text-3xl font-heading mb-6 relative z-10" data-id="element-170">
            El Error de las 1,200 Calorías
          </h3>
          <p className="text-lg md:text-xl font-body text-brand-cream/90 leading-relaxed max-w-3xl mx-auto relative z-10" data-id="element-171">
            Seguir una dieta de 1,200 calorías en este estado es como intentar
            apagar un incendio forestal con un vaso de agua: solo logras
            estresar más a tu cuerpo, obligándolo a aferrarse a cada gramo de
            grasa abdominal como mecanismo de supervivencia.
          </p>
        </motion.div>
      </div>
    </section>;
}